import { useState } from "react"
import { ExtraServiceEntity } from "../../Objects/ExtraService/ExtraServiceEntity"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { EMoneyConditionType } from "../../Enum/EMoneyConditionType"
import { EAutoType } from "../../Enum/EAutoType"

export const useCreateExtraService = () => {
  const [name, setName] = useState("")

  const [description, setDescription] = useState("")

  const [value, setCoast] = useState("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [conditionType, setConditionType] = useState<EMoneyConditionType>(EMoneyConditionType.Percentage)

  const [isAutomatic, setIsAutomatic] = useState<EAutoType>(EAutoType.NotAuto)

  const [extraService, setExtraService] = useState<ExtraServiceEntity | null>(null)

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)
  const handleCoastChange = (e: React.ChangeEvent<HTMLInputElement>) => setCoast(e.target.value)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (extraService: ExtraServiceEntity | null | undefined) => {
    if (extraService) {
      setExtraService(extraService)
      setName(extraService.name)
      setDescription(extraService.description)
      setCoast(extraService.valueBase.toString())
      setIsAutomatic(extraService.isAutomatic === true ? EAutoType.Auto : EAutoType.NotAuto)
      setStatus(extraService.status)
      setConditionType(extraService.conditionType)
    }
  }

  const handleSubmitForm = (): ExtraServiceEntity | { errors: ValidationError[] } => {
    return new ExtraServiceEntity({
      id: extraService?.id,
      status: status,
      valueBase: Number(value),
      name: name,
      description: description,
      conditionType: conditionType,
      isAutomatic: isAutomatic === EAutoType.Auto,
    })
  }

  return {
    name,
    description,
    status,
    value,
    isAutomatic,
    conditionType,
    setConditionType,
    handleNameChange,
    handleCoastChange,
    handleDescriptionChange,
    setIsAutomatic,
    handleStatusChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
